import React from 'react';

import {BulkActionTool} from 'src/components/bulk-tool';
import {
    getUserStatesBulkUpdateProgress,
    stopUserStatesBulkUpdate,
    userStateBulkUpdate,
} from 'src/openapi/admin/apis/UserStateBulkUpdateApi';
import {useAppDispatch} from 'src/store/hooks';

import {
    MODAL_WIDTH,
    TOOL_PROGRESS_LABEL,
    TOOL_STACK_OVERFLOW_MESSAGE,
    TOOL_TASK,
    TOOL_TITLE,
} from './constants';
import {UpdateUserStateModal} from './update-user-state.modal';
import {
    selectUpdateUserStateBulkUuid,
    selectUpdateUserStateTask,
    setBackgroundTask,
    setShown,
    setUuid,
} from './update-user-state.slice';

import type {UpdateUserState} from 'src/openapi/admin/models/UpdateUserState';

type Props = {
    shown: boolean,
    userIds: number[],
    onDone: () => void,
    onClose: () => void,
};

export const UpdateUserStateTool = ({shown, userIds, onDone, onClose}: Props) => {
    const apiDispatch = useAppDispatch();

    return (
        <BulkActionTool<UpdateUserState>
            shown={shown}
            onClose={onClose}
            width={MODAL_WIDTH}

            toolTask={TOOL_TASK}
            toolName={TOOL_TITLE}
            progressLabel={TOOL_PROGRESS_LABEL}

            taskSelector={selectUpdateUserStateTask}
            uuidSelector={selectUpdateUserStateBulkUuid}

            setUuid={setUuid}
            setTask={setBackgroundTask}
            setResultShown={setShown}
            saveActionRequest={(updateUserState, options) => (
                apiDispatch(userStateBulkUpdate({...options, updateUserState}))
            )}
            getProgress={id => apiDispatch(getUserStatesBulkUpdateProgress({id}))}
            stopAction={id => apiDispatch(stopUserStatesBulkUpdate({id}))}

            stackOverflowMessage={TOOL_STACK_OVERFLOW_MESSAGE}
            onDone={onDone}>
            {({onCloseModal, processAction}) => (
                <UpdateUserStateModal {...{userIds, onCloseModal, processAction}}/>
            )}
        </BulkActionTool>
    );
};
